var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4947523 4.2097345v4.4966264C13.4947523 9.42213 11.2590927 10 8.50064912 10s-4.99406793-.5796158-4.99406793-1.2936391V4.2097345l4.45542329.888601c.17779375.0349156.35734783.0523734.53866225.0523734.18131441 0 .36262883-.0174578.53866224-.0523734l4.45542333-.888601zM8.50066673 0c.14610773 0 .29219786.015712.43480253.0436445l7.71202384 1.5397763c.4700092.094272.4700092.7611767 0 .8554313l-.6777287.1344074v3.4506426c.1672318.144917.2728518.3578845.2728518.5970561 0 .4382078-.3590905.7943291-.800952.7943291-.4418439 0-.800952-.3561213-.800952-.7943291 0-.2374084.10562-.4521391.2728518-.5970561v-3.239386l-1.4188293.2828161-4.55926544.9095504c-.1443474.0296782-.2886948.0436444-.43480253.0436444-.14610774 0-.29219787-.015712-.43480253-.0436444l-4.55926541-.9095504-3.15275843-.6284801c-.47178715-.0942721-.47178715-.7611593 0-.8554313L8.0658642.0436445C8.21021159.0139662 8.35455899 0 8.50066673 0z",
    fill: "#C1CEDE",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.20ab8bc96f3a8526fa47bb29bde43f3d.svg";
export { ForwardRef as ReactComponent };